module.exports = __webpack_public_path__ + "static/ef_magazine.svg";